export default __webpack_public_path__ + "static/media/ic_central_african_republic.76a7bd19.svg";